import { TreeWithId } from '@livv/models';
import { Box, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import BookCard from '@components/Books/BookCard';
import { THEME_ORDER } from '@utils/consts/trees';
import { buildThemesFromBooks } from '@utils/trees';

interface BookListProps {
    books: TreeWithId[];
}

const BookList: FC<BookListProps> = ({ books }) => {
    const { lang, t } = useTranslation('books');

    const treesByThemes = buildThemesFromBooks(books);

    return !books.length ? (
        <Typography color="textSecondary">{t('noResult')}</Typography>
    ) : (
        <Box>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    mb: 2,
                }}
            >
                <Typography sx={{ color: 'text.secondary' }}>
                    {`${books.length} ${t('book', { count: books.length })}`}
                </Typography>
            </Box>
            {THEME_ORDER.map(
                (theme, index) =>
                    Boolean(treesByThemes[theme].length) && (
                        <Box key={theme}>
                            <Typography sx={{ mb: 2, mt: index ? 8 : 0 }} variant="h2">
                                {t(`theme.${theme}`)}
                            </Typography>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gap: 2,
                                    gridTemplateColumns: 'repeat(5, minmax(auto, 1fr))',
                                }}
                            >
                                {treesByThemes[theme]
                                    .sort((tree1, tree2) => {
                                        return tree1.title.localeCompare(tree2.title, lang);
                                    })
                                    .map((tree) => (
                                        <BookCard key={tree.id} tree={tree} />
                                    ))}
                            </Box>
                        </Box>
                    ),
            )}
        </Box>
    );
};

export default BookList;
